import { FC, ReactNode } from "react";

import { StripeAPIKey } from "config";

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

// Hoist outside the component so the same Promise instance is reused across
// renders and strict-mode double-mounts. Stripe's <Elements> does not allow
// the `stripe` prop to change after initial mount.
const stripePromise = loadStripe(StripeAPIKey);

const StripeProvider: FC<{ children?: ReactNode }> = props => {
  const { children } = props;

  return <Elements stripe={stripePromise}>{children}</Elements>;
};
export default StripeProvider;
